import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import styles from './Logo.module.css';

function Logo() {
  const { logoImageSrc, logoImageAlt, showLogoImage } =
    useSearchParamOrDefaultProps();

  return (
    showLogoImage === 'true' && (
      <figure className={styles.logoWrapper}>
        <img className={styles.logo} src={logoImageSrc} alt={logoImageAlt} />
      </figure>
    )
  );
}

Logo.displayName = 'Logo';

export default Logo;
